const getLanguage = require('./getLanguage'),
    constants = require('./constants');

module.exports = function (passwordPolicyModel) {
    let language = getLanguage() || constants.defaultLanguage;
    return passwordPolicyModel.get('errorMessage')[language];
};
